export enum MonitoringProposalTabsEnum {
    PENDING_CREDIT = 1,
    AFFILIATED = 2,
    SERPRO = 3,
    NOT_AFFILIATED = 4,
    PRODUCT_BASE = 5,
    PENDING_NOTENABLE = 6,
    PAYMENT_SPLIT = 7
}
